class HaemProductForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    if (!this.form) return;
    this.button = this.form.querySelector('[type="submit"]');
    this.status = this.closest('[data-section-id]')?.querySelector('[data-product-status]');
    this.form.addEventListener('submit', this.onSubmit.bind(this));
  }

  async onSubmit(event) {
    event.preventDefault();
    if (!this.button || this.button.disabled) return;
    const originalLabel = this.button.textContent.trim();
    this.button.disabled = true;
    this.button.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(this.form)
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Der Artikel konnte nicht in den Warenkorb gelegt werden.');

      const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`);
      const cart = await cartResponse.json();
      document.querySelectorAll('[data-cart-count]').forEach((count) => {
        count.textContent = cart.item_count;
        count.hidden = cart.item_count === 0;
      });

      if (this.status) this.status.textContent = this.status.dataset.success || 'Zum Warenkorb hinzugefügt.';
      this.button.classList.add('is-success');
      window.setTimeout(() => {
        this.button.classList.remove('is-success');
        this.button.textContent = originalLabel;
      }, 1800);
    } catch (error) {
      if (this.status) this.status.textContent = error.message;
    } finally {
      this.button.disabled = false;
      this.button.removeAttribute('aria-busy');
    }
  }
}

if (!customElements.get('product-form')) customElements.define('product-form', HaemProductForm);

const trapFocus = (container) => {
  const focusable = [...container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')];
  if (focusable.length) focusable[0].focus();
};

const setOverlay = (element, open) => {
  if (!element) return;
  element.hidden = !open;
  document.body.classList.toggle('is-locked', open);
  if (open) trapFocus(element);
};

document.addEventListener('click', (event) => {
  if (event.target.closest('[data-menu-open]')) {
    setOverlay(document.querySelector('#MobileMenu'), true);
    event.target.closest('[data-menu-open]').setAttribute('aria-expanded', 'true');
  }
  if (event.target.closest('[data-menu-close]')) {
    setOverlay(document.querySelector('#MobileMenu'), false);
    document.querySelector('[data-menu-open]')?.setAttribute('aria-expanded', 'false');
  }
  if (event.target.closest('[data-filter-open]')) {
    document.querySelector('[data-filters-drawer]')?.classList.add('is-open');
    document.body.classList.add('is-locked');
  }
  if (event.target.closest('[data-filter-close]')) {
    document.querySelector('[data-filters-drawer]')?.classList.remove('is-open');
    document.body.classList.remove('is-locked');
  }

  const minus = event.target.closest('[data-quantity-minus]');
  const plus = event.target.closest('[data-quantity-plus]');
  if (minus || plus) {
    const input = (minus || plus).parentElement.querySelector('input[type="number"]');
    if (!input) return;
    const current = Number.parseInt(input.value, 10) || 1;
    input.value = plus ? current + 1 : Math.max(Number.parseInt(input.min, 10) || 1, current - 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  const mediaButton = event.target.closest('[data-media-target]');
  if (mediaButton) {
    const gallery = mediaButton.closest('[data-product-gallery]');
    gallery.querySelectorAll('[data-media-target]').forEach((button) => button.classList.toggle('is-active', button === mediaButton));
    gallery.querySelectorAll('[data-media-id]').forEach((media) => {
      const active = media.dataset.mediaId === mediaButton.dataset.mediaTarget;
      media.hidden = !active;
      media.classList.toggle('is-active', active);
    });
  }
});

document.addEventListener('change', (event) => {
  if (event.target.matches('[data-localization-select]')) event.target.form.submit();
  if (event.target.matches('[data-sort-select]')) event.target.form.submit();

  if (event.target.matches('[data-variant-select]')) {
    const selected = event.target.selectedOptions[0];
    const section = event.target.closest('[data-section-id]');
    const price = section?.querySelector('[data-product-price] .price');
    const stickyPrice = section?.querySelector('[data-sticky-price] .price');
    const button = section?.querySelector('[data-add-to-cart]');
    const stickyButton = section?.querySelector('[data-sticky-add]');
    if (selected.dataset.price) {
      if (price) price.innerHTML = `<span>${selected.dataset.price}</span>`;
      if (stickyPrice) stickyPrice.innerHTML = `<span>${selected.dataset.price}</span>`;
    }
    if (button) {
      const available = selected.dataset.available === 'true';
      button.disabled = !available;
      const label = button.querySelector('[data-add-label]');
      const availableText = label?.dataset.available || 'In den Warenkorb';
      const soldOutText = label?.dataset.soldOut || 'Ausverkauft';
      if (label) label.textContent = available ? availableText : soldOutText;
      if (stickyButton) {
        stickyButton.disabled = !available;
        const stickyLabel = stickyButton.querySelector('[data-sticky-add-label]');
        if (stickyLabel) stickyLabel.textContent = available ? availableText : soldOutText;
      }
    }
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  setOverlay(document.querySelector('#MobileMenu'), false);
  document.querySelector('[data-filters-drawer]')?.classList.remove('is-open');
  document.body.classList.remove('is-locked');
});

const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (!entry.isIntersecting) return;
    entry.target.classList.add('is-visible');
    revealObserver.unobserve(entry.target);
  });
}, { rootMargin: '0px 0px -8% 0px' });

document.querySelectorAll('.product-card, .collection-tile, .image-text__grid, .article-card').forEach((element) => {
  element.classList.add('reveal-on-scroll');
  revealObserver.observe(element);
});

/* Sticky add-to-cart bar (mobile) */
const stickyBar = document.querySelector('[data-sticky-atc]');
const stickyAnchor = document.querySelector('.product-form__row');
if (stickyBar && stickyAnchor && 'IntersectionObserver' in window) {
  const stickyButton = stickyBar.querySelector('[data-sticky-add]');
  stickyButton?.addEventListener('click', () => {
    document.querySelector('[data-add-to-cart]')?.click();
  });
  const stickyObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      stickyBar.classList.toggle('is-visible', scrolledPast);
    });
  }, { threshold: 0 });
  stickyObserver.observe(stickyAnchor);
}
